import {useState} from 'react';
import { useNavigate } from 'react-router-dom';

import useError from '../../hooks/useError';
import useUser from "../../hooks/useUser";
import {useCreateCaseMutation} from "../../redux/services/caseApi";
import AppDashboard from "../AppDashboard";
import CaseForm from "../../components/cases/CaseForm";

const NewCasePage = props => {
  const [submitting, setSubmitting] = useState(false);
  const [createCase] = useCreateCaseMutation();
  const navigate = useNavigate();
  const user = useUser();
  const providerId = user?.provider?.id;
  const {create: setError} = useError();
  return (
    <AppDashboard title='New Case' loading={false}>
      <CaseForm 
        disabled={submitting}
        requirePatientSex={true}
        afterSubmit={() => navigate('/providers/cases')}
      />
    </AppDashboard>
  );
};

export default NewCasePage;